import BuilderModel from "../../../../common/models/tracked/builderModel";
import pluralizeable from "../../../../common/mixins/pluralizeable";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";

export default class CharacterCount extends BuilderModel {
  min: number | '' | null;
  max: number | '' | null;
  show_char_limit: boolean;
  char_limit_message: string;

  static repo: IRepo<CharacterCount> = new Repo<CharacterCount>('characterCounts', CharacterCount);

  get isCollectionRoot(): boolean {
    return false;
  }

  get hasMin(): boolean {
    return this.min !== null && this.min !== '' && this.min >= 0;
  }

  get hasMax(): boolean {
    return this.max !== null && this.max !== '' && this.max >= 0;
  }

  get hasMinOrMax(): boolean {
    return this.hasMin || this.hasMax;
  }

  get minMaxEqual(): boolean {
    return this.hasMin && this.hasMax && this.min === this.max;
  }

  get rangeHTML(): string {
    let text = '';
    if (this.minMaxEqual) {
      text += pluralizeable.filters.pluralize('character', this.min as number);
    } else {
      if (this.hasMin) {
        text += this.min;
      } else {
        text += 0;
      }
      text += ' - ';
      if (this.hasMax) {
        text += this.max;
      } else {
        text += "&infin;";
      }
      text += ' characters';
    }
    return text;
  }

  beforeSetCallback() {
    if (!this.hasMinOrMax) {
      this.show_char_limit = true;
    }
  }

  afterSetCallback() {
    if (!this.hasMinOrMax) {
      this.show_char_limit = false;
    }
  }
}